import * as React from "react";
import { useTranslation } from "react-i18next";
import SectionComponent from "components/common/Section/SectionComponent";
import { LinkContainer, ReadOnlyFormGroup } from "components/common";
import Routes from "routing/Routes";
import { Button, Alert, ButtonToolbar } from "components/bootstrap";
import LicenseCheck from "license/LicenseCheck";
const OidcConfigSection = ({ backendId, groupSyncBackend, getReadableSelectionType }) => {
  const { t } = useTranslation("enterprise_authentication");
  const { config, selectionType } = groupSyncBackend || {};
  return /* @__PURE__ */ React.createElement(
    SectionComponent,
    {
      title: t("oidc.oidc_config_section.title"),
      headerActions: /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.SYSTEM.AUTHENTICATION.BACKENDS.edit(backendId, "group_sync") }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "small" }, t("oidc.oidc_config_section.edit"))))
    },
    groupSyncBackend ? /* @__PURE__ */ React.createElement(LicenseCheck, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("oidc.oidc_config_section.groups_claim"), value: config == null ? void 0 : config.groupsClaim }), /* @__PURE__ */ React.createElement(
      ReadOnlyFormGroup,
      {
        label: t("oidc.oidc_config_section.selection_type"),
        value: getReadableSelectionType(selectionType)
      }
    )) : /* @__PURE__ */ React.createElement(Alert, null, t("oidc.oidc_config_section.not_configured"))
  );
};
export default OidcConfigSection;
